/* eslint-disable import/no-anonymous-default-export */
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm,  } from '@insticator/insticator-ui'


/* ++++++++++ --------------- ARTICLE SENTIMENT : CONFIG V2 : STYLES --------------- ++++++++++ */
export default theme => ({
  articlesentimentv2configpage: {
    '& #content': {
      padding: '0 !important', // removing initial padding as it effects child elements that are sticky positioned (they maintain this top padding which looks strange)
      '& .pageheader': {
        padding: '3.5em 1.875em 1.875em 1.875em' // adding padding to child elements of content instead to preserve proper spacing
      },
      '& .pagecontent': {
        padding: '0em 1.875em 1.875em 1.875em' // adding padding to child elements of content instead to preserve proper spacing, but removing top padding since header element has bottom padding
      },
      '& .incontentmessage': {
        margin: '3.5em 1.875em 0 1.875em' // needed because of sticky positioning and removing padding from content element
      }
    },
    '& .configv2controller.opened-true': {
      background: '#fff', // ensure the header has a background so as elements scroll beneath it they remain invisible
      position: 'sticky', // keep header element sticky so user can always see what section of the config they are in
      top: '0',
      zIndex: '1000' // make sure to keep the header over top of whatever elements are scrolling beneath it
    },
    '& .type-checkbox': {
      '& label': {
        marginBottom: '0 !important' 
      }
    },
    '& .radiospan': {
      width: pxToEm(20),
      height: pxToEm(20),
      '&::after': {
        top: pxToEm(5),
        left: pxToEm(5),
        width: pxToEm(6),
        height: pxToEm(6)
      }
    },
    '& .fieldicon': {
      '& > svg': {
        width: pxToEm(20),
        height: pxToEm(20),
        '& > path': {
          fill: '#7A87BC'
        }
      }
    },
    '& .configbutton': {
      background: '#FFF',
      color: '#061240',
      border: '1px solid #061240',
      width: 'auto'
    },
    '& .warningicon': {
      '& path': {
        fill: '#7E92B8'
      }
    },
    '& .name-productmanagermessage': {
      marginBottom: pxToEm(32),
      maxWidth: pxToEm(1280),
      '& .productmanagerlink': {
        textDecoration: 'underline', 
        fontWeight: 600, 
        cursor: 'pointer'
      }
    },
    '& .emptystate': {
      background: '#FFF',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      rowGap: pxToEm(8),
      minHeight: pxToEm(480),
      padding: pxToEm(32),
      '& .bodycopy': {
        maxWidth: '100%'
      }
    }
  }
});
